import React from "react";
import SchoolContent from "@/education-components/SchoolContent";
import { academyFetchData } from "@/service/api";
import { useDispatch } from "react-redux";
import { fetchDataSuccess } from "../../../src/redux/dataSlice";
import CommonLayout from "@/education-components/CommonLayout/CommonLayout";
import Page404 from "../404";

const Academy = ({ data }) => {
  const dispatch = useDispatch();

  if (data === null || data?.data?.data?.aedschoolpage === undefined) {
    return <div>{data === null && <Page404 />}</div>;
  }

  dispatch(fetchDataSuccess(data?.data?.data));

  return (
    <CommonLayout>
      <SchoolContent />
    </CommonLayout>
  );
};

export async function getServerSideProps({ params }) {
  try {
    const slugs = params?.slug;
    const data = await academyFetchData(slugs);

    if (data === undefined) {
      return {
        props: {
          data: null,
        },
      };
    }

    return {
      props: {
        data,
      },
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      props: {
        data: null,
      },
    };
  }
}

export default Academy;
